module.exports = __webpack_public_path__ + "static/media/male.f9959071.svg";